/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react'
import Context from '../context/context'

const Popup = ({ modalState, setModalState }) => {

  const context = useContext(Context);
  const { cartHandler, selectedMenu } = context;

  const [itemsArray, setItemsArray] = useState()
  const [multiArray, setMultiArray] = useState()
  const [addonArray, setAddonArray] = useState()

  useEffect(() => {

    const menu = selectedMenu;
    if (!menu) return;

    let itemsArray = [];
    menu.category_and_items.forEach(category => category.menu_items.forEach(item => itemsArray.push(item)));
    setItemsArray(itemsArray);

    let addonArray = modalState.data.menu_item_addons ?
      modalState.data.menu_item_addons.map(addon => {
        return {
          ...addon,
          addon_item_details: addon.addon_item_details.map((addonItem, i) => {
            const item = itemsArray.find(item => item?.item_uuid === addonItem.item_uuid);
            if (+item?.item_status === 1 && item?.item_uuid !== modalState.data.item_uuid && +item?.item_availability === 1)
              return addonItem
            else return {}
          })?.filter(x => Object.keys(x)?.length > 0)
        }
      })?.filter(x => x?.addon_item_details?.length > 0) : []

    let multiArray = modalState?.data?.menu_item_multi
      ?.map(multi => ({ "title": multi.multi_title, "data": multi.multi_item_details }))

    if (!multiArray?.length && !addonArray?.length) {
      cartHandler({ item_uuid: modalState?.data?.item_uuid, action: 'increment' });
      setModalState({ isVisible: false, data: null });
    }
    else {
      setAddonArray(addonArray)
      setMultiArray(multiArray)
    }
  }, [])

  function submitHandler() {
    let addonsList = [];
    let multiList = [];
    var doReturn = [];

    document.querySelectorAll('[name="popup_inputs"]').forEach((div, index) => {

      let minValue = Number(div.getElementsByClassName('min-max')[0].firstChild.getElementsByTagName('span')[0].innerHTML)
      let maxValue = Number(div.getElementsByClassName('min-max')[0].firstChild.nextElementSibling.getElementsByTagName('span')[0].innerHTML)

      const array = []
      Array.from(div.getElementsByClassName('item')).forEach(inputDiv => {

        const input = inputDiv.getElementsByTagName('input')[0]

        if (input.checked === true) {

          console.log('CHECKED INPUT: ', input)
          const category = input.getAttribute('category')
          let object = category === 'addon' ?
            {
              item_uuid: input.labels[0].innerText,
              name: input.labels[1].innerText,
              price: input.labels[2].innerText
            }
            : category === 'multi' && {
              name: input.labels[0].innerText,
              price: input.labels[1].innerText
            }
          array.push(object);
          category === 'addon' && addonsList.push(object);
          category === 'multi' && multiList.push(object);
        }

        if (array.length >= minValue && array.length <= maxValue) {
          doReturn[index] = false
          div.getElementsByClassName('min-max')[0].childNodes
            .forEach(element => element.style.border = '1px solid green')
        }
        else {
          doReturn[index] = true
          div.getElementsByClassName('min-max')[0].childNodes
            .forEach(element => element.style.border = '1px solid red')
        }
      });
    });

    doReturn = doReturn.find(value => value === true);
    if (doReturn) return;

    cartHandler({ item_uuid: modalState?.data?.item_uuid, addons: addonsList, multi: multiList, action: 'increment' });
    setModalState({ isVisible: false, data: null });
  }

  function addIndex() {
    let index = -1;
    if (!document.getElementsByClassName('popup-item')) return console.warn("no items found, function returned!!");
    Array.from(document.getElementsByClassName('popup-item')).forEach(element => {
      element.setAttribute('popup-index', ++index)
    })
  }

  return (
    <>
      {addonArray?.length > 0 || multiArray?.length > 0 ? <div className='popup-overlay active'>
        <div className='popup active'>
          <div className="popup-actions">

            <button onClick={() => setModalState({ ...modalState, isVisible: false })} className='cancel popup-cancel'>Cancel</button>
            <button className='done popup-done' onClick={submitHandler} >Done</button>

          </div>
          <div>
            {addonArray.map(addon => {

              return <div key={Math.random()} className="popup-content" name="popup_inputs" id={addon.addon_title} >
                <div className="popup-heading">{addon.addon_title}</div>
                <div className="min-max">
                  <div className="min">Min : <span>{addon.addon_min}</span></div>
                  <div className="max">Max : <span>{addon.addon_max}</span></div>
                </div>
                <AddOnItems
                  key={Math.random()}
                  addIndex={addIndex}
                  addon={addon}
                  itemsArray={itemsArray}
                />
              </div>
            })}
            {multiArray.map(multiServingObject => {

              return <div
                key={Math.random()}
                className="popup-content"
                name="popup_inputs"
                id={multiServingObject.title}
              >
                <div className="popup-heading">{multiServingObject.title}</div>
                <div className="min-max">
                  <div className="min">Min <span>1</span></div>
                  <div className="max">Max <span>1</span></div>
                </div>
                {multiServingObject.data.map(multi =>
                  <Item
                    key={Math.random()}
                    addIndex={addIndex}
                    multi={multi}
                    sectionName={multiServingObject.title}
                  />)}
              </div>
            })}
            {<div style={{ display: 'none' }}>{setTimeout(() => addIndex(), 100)}</div>}
          </div>
        </div>
      </div> : ''}
    </>
  )
};

const AddOnItems = ({ addon, itemsArray, addIndex }) => {

  let addon_items = addon.addon_item_details;

  return (<>
    {addon_items.map((addonItem, index) => {
      const item = itemsArray.find(item => item?.item_uuid === addonItem.item_uuid);
      if (item)
        return <Item key={Math.random()} addIndex={addIndex} item={item} sectionName={addon.addon_title} addonItem={addonItem} />
      else
        return ''
    })}
  </>)
}

const Item = ({ item, addonItem, sectionName, multi, addIndex }) => {

  const [isSelected, setIsSelected] = useState(false);
  const multi_input_name = Math.random()

  useEffect(() => {
    addIndex()
  }, [isSelected])

  return <>
    {!multi &&
      <div className={`item popup-item ${isSelected ? 'selected' : ''}`} onClick={(e) => {
        e.preventDefault()
        setIsSelected(!isSelected)
      }}>

        <input type="checkbox" id={item?.item_name}
          parent={sectionName}
          style={{ display: 'none' }}
          className='addons-Input'
          checked={isSelected}
          onChange={e => { }}
          category="addon"
        />
        <label
          htmlFor={item?.item_name} className="addon_item_uuid" style={{ display: "none" }}
        >{item?.item_uuid}
        </label>
        <label htmlFor={item?.item_name} className="name">{item?.item_name}</label>
        <label htmlFor={item?.item_name} className="price">{addonItem.price}</label>
      </div>}

    {multi &&
      <div key={Math.random()} className={`item popup-item ${isSelected ? 'selected' : ''}`}
        onClick={(e) => {
          e.preventDefault()
          setIsSelected(!isSelected)
        }}>

        <input type="checkbox" id={multi_input_name}
          parent={sectionName}
          style={{ display: 'none' }}
          className='addons-Input'
          checked={isSelected}
          onChange={e => { }}
          category="multi"
        />
        <label htmlFor={multi_input_name} className="name">{multi.item_multi_name}</label>
        <label htmlFor={multi_input_name} className="price">{multi.item_multi_price}</label>
      </div>}
  </>
}

export default Popup
